 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import BOOKDESCRIPTION from '@/components/bookdescription'
 import PRAISEFORRICKWILBER from '@/components/praiseforrickwilber'
 import TITLEPAGE from '@/components/titlepage'
 import CONTENTS from '@/components/contents'
 import COPYRIGHT from '@/components/copyright'
 import INTRODUCTION from '@/components/introduction'
 import DEDICATION from '@/components/dedication'
 import INTRODUCTIONTOTODAYISTODAY from '@/components/introductiontotodayistoday'
 import TODAYISTODAY from '@/components/todayistoday'
 import INTRODUCTIONTORAMBUNCTIOUS from '@/components/introductiontorambunctious'
 import RAMBUNCTIOUS from '@/components/rambunctious'
 import INTRODUCTIONTOICECOVERSTHEHOLE from '@/components/introductiontoicecoversthehole'
 import ICECOVERSTHEHOLE from '@/components/icecoversthehole'
 import INTRODUCTIONTOWALKINGTOBOSTON from '@/components/introductiontowalkingtoboston'
 import WALKINGTOBOSTON from '@/components/walkingtoboston'
 import INTRODUCTIONTOSOMETHINGREAL from '@/components/introductiontosomethingreal'
 import SOMETHINGREAL from '@/components/somethingreal'
 import INTRODUCTIONTOSEVERALITEMSOFINTEREST from '@/components/introductiontoseveralitemsofinterest'
 import SEVERALITEMSOFINTEREST from '@/components/severalitemsofinterest'
 import INTRODUCTIONTOHOPEASANELEMENTOFCOLDDARKMATTER from '@/components/introductiontohopeasanelementofcolddarkmatter'
 import HOPEASANELEMENTOFCOLDDARKMATTER from '@/components/hopeasanelementofcolddarkmatter'
 import INTRODUCTIONTOPRICES from '@/components/introductiontoprices'
 import PRICES from '@/components/prices'
 import INTRODUCTIONTOWARBRIDE from '@/components/introductiontowarbride'
 import WARBRIDE from '@/components/warbride'
 import LOVE_2 from '@/components/love_2'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
 import ADDITIONALCOPYRIGHTINFORMATION from '@/components/additionalcopyrightinformation'
 import IFYOULIKED from '@/components/ifyouliked'
 import OTHERWORDFIREPRESSTITLESBYRICKWILBER from '@/components/otherwordfirepresstitlesbyrickwilber'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/introductiontotodayistoday",
 			"name" : "introductiontotodayistoday",
 			"component" : INTRODUCTIONTOTODAYISTODAY
 		},
 		{
 			"path" : "/todayistoday",
 			"name" : "todayistoday",
 			"component" : TODAYISTODAY
 		},
 		{
 			"path" : "/introductiontorambunctious",
 			"name" : "introductiontorambunctious",
 			"component" : INTRODUCTIONTORAMBUNCTIOUS
 		},
 		{
 			"path" : "/rambunctious",
 			"name" : "rambunctious",
 			"component" : RAMBUNCTIOUS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js